import { render, staticRenderFns } from "./RidesPerVehicleType.vue?vue&type=template&id=349c15a4&scoped=true&"
import script from "./RidesPerVehicleType.vue?vue&type=script&lang=js&"
export * from "./RidesPerVehicleType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349c15a4",
  null
  
)

export default component.exports